'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { useToast } from '@common/hooks';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import SvgTarget2 from '@common/icon/SvgTarget2';
import { useState } from 'react';
import { RegionPickerDialog } from '@/components/client/RegionSelect/RegionPickerDialog';
import type { WelloPolicyCode } from '@/components/client/RegionSelect/useRegionMetaData';
import { useRegionMetaData } from '@/components/client/RegionSelect/useRegionMetaData';
import type { SEARCH_PARAMS_TYPE } from '@/constants';
import { GEOLOCATION_VIEW_TYPE } from '@/constants/geo';
import { useLocation } from '@/hooks/useLocation';
interface SelectedRegion {
  mainRegion: WelloPolicyCode;
  subRegion: WelloPolicyCode;
}
interface FeedRegionBarProps {
  value?: SEARCH_PARAMS_TYPE.SELECTED_REGION;
  onChange?: (value: SelectedRegion) => void;
}
export const FeedRegionBar = t0 => {
  const $ = _c(37);
  const {
    value,
    onChange
  } = t0;
  const regionMetaDataQuery = useRegionMetaData();
  const regionMetaData = regionMetaDataQuery.data;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      geolocationViewType: GEOLOCATION_VIEW_TYPE.HOME_TOWN_NEWS
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    refetch: getLocation,
    isLoading: isLocationLoading
  } = useLocation(t1);
  const {
    toast
  } = useToast();
  const [opened, setOpened] = useState(false);
  const isMetaLoading = regionMetaDataQuery.isLoading;
  let t2;
  if ($[1] !== regionMetaData?.subRegionByCode || $[2] !== value) {
    t2 = value?.subRegionCode ? regionMetaData?.subRegionByCode.get(value.subRegionCode)?.value ?? "" : "";
    $[1] = regionMetaData?.subRegionByCode;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const selectedRegionText = t2;
  let t3;
  if ($[4] !== getLocation || $[5] !== onChange || $[6] !== regionMetaData?.mainRegionByCode || $[7] !== regionMetaData?.subRegionByCode || $[8] !== toast) {
    t3 = async () => {
      const location = await getLocation();
      const {
        codeRegion,
        codeSubRegion
      } = location.data ?? {};
      const foundMain = codeRegion ? regionMetaData?.mainRegionByCode.get(codeRegion) : undefined;
      const foundSub = codeSubRegion ? regionMetaData?.subRegionByCode.get(codeSubRegion) : undefined;
      if (!foundMain || !foundSub) {
        toast({
          type: "fail",
          message: "\uC704\uCE58 \uC815\uBCF4\uB97C \uAC00\uC838\uC624\uC9C0 \uBABB\uD588\uC5B4\uC694."
        });
        return;
      }
      onChange?.({
        mainRegion: foundMain,
        subRegion: foundSub
      });
      toast({
        message: "\uD604\uC7AC \uC704\uCE58\uAC00 \uC124\uC815\uB418\uC5C8\uC5B4\uC694."
      });
    };
    $[4] = getLocation;
    $[5] = onChange;
    $[6] = regionMetaData?.mainRegionByCode;
    $[7] = regionMetaData?.subRegionByCode;
    $[8] = toast;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleSelectCurrentLocation = t3;
  const t4 = selectedRegionText ? `지역 선택: 현재 ${selectedRegionText}` : "\uC9C0\uC5ED \uC120\uD0DD";
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(true);
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = selectedRegionText || "\uC9C0\uC5ED";
  let t7;
  if ($[11] !== t6) {
    t7 = <span className="truncate font-600 text-Gray-700 typo-body4">{t6}</span>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span aria-hidden="true" className="flex size-24 items-center justify-center"><SvgChevrondown className="size-16 text-Gray-700" name="Arrow-Down-4" /></span>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== isMetaLoading || $[15] !== opened || $[16] !== t4 || $[17] !== t7) {
    t9 = <button aria-expanded={opened} aria-haspopup="dialog" aria-label={t4} className="flex items-center rounded-xsmall transition-colors duration-150 hover:bg-Gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500 disabled:opacity-50" disabled={isMetaLoading} onClick={t5}>{t7}{t8}</button>;
    $[14] = isMetaLoading;
    $[15] = opened;
    $[16] = t4;
    $[17] = t7;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = isLocationLoading || isMetaLoading;
  let t11;
  if ($[19] !== isLocationLoading) {
    t11 = <span aria-hidden="true" className="flex size-14 items-center justify-center">{isLocationLoading ? <Spinner size={14} /> : <SvgTarget2 className="size-14" name={"\uC704\uCE58 \uC815\uBCF4 \uC5C5\uB370\uC774\uD2B8"} />}</span>;
    $[19] = isLocationLoading;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== handleSelectCurrentLocation || $[22] !== isLocationLoading || $[23] !== t10 || $[24] !== t11) {
    t12 = <button aria-busy={isLocationLoading} aria-label={"\uD604\uC7AC \uC704\uCE58\uB85C \uC9C0\uC5ED \uC124\uC815"} className="flex items-center gap-4 rounded-xsmall px-4 py-2 font-500 text-Gray-700 transition-colors duration-150 typo-body4 hover:bg-Gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-B-500 disabled:opacity-50" disabled={t10} onClick={handleSelectCurrentLocation}>{t11}현위치</button>;
    $[21] = handleSelectCurrentLocation;
    $[22] = isLocationLoading;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setOpened(false);
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== onChange) {
    t14 = t15 => {
      const {
        mainRegion,
        subRegion
      } = t15;
      if (!mainRegion || !subRegion) {
        return;
      }
      onChange?.({
        mainRegion,
        subRegion
      });
    };
    $[27] = onChange;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== opened || $[30] !== t14 || $[31] !== value) {
    t15 = <RegionPickerDialog opened={opened} onClose={t13} onConfirm={t14} value={value} title={"\uAD00\uC2EC \uC9C0\uC5ED\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694"} />;
    $[29] = opened;
    $[30] = t14;
    $[31] = value;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t15 || $[35] !== t9) {
    t16 = <div aria-label={"\uC9C0\uC5ED \uC120\uD0DD"} role="group" className="flex w-full items-center justify-between border-b-1 border-b-Gray-100 bg-Gray-white px-16 pb-8 pt-4 xl:border-b-0 xl:bg-transparent">{t9}{t12}{t15}</div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t9;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
};